import React, { useState, useEffect } from 'react';
import '../../css/ItemCard.css';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import Lightbox from 'react-image-lightbox';
import { motion } from 'framer-motion';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Currency from './Currency';
import { useTranslation } from 'react-i18next';

const moodImageNames = ['image', 'moodImage1', 'moodImage2', 'moodImage3', 'detailImage', 'frontImage', 'backImage', 'sideImage'];

const DELAY = 1000;

export default function ItemCard({ item, addCartItem, open }) {
	const [openLightBox, setOpenLightBox] = useState(undefined);
	const [amount, setAmount] = useState(0);
	const [addClass, setAddClass] = useState('add-to-cart-button invisible');
	const { sku, description, price, productgroup, imageMedium, size, currency = 'EUR', availability, moodImages, eta = null, discount } = item || {};
	const { t } = useTranslation();
	useEffect(() => {
		if(open) {
			const timeout = setTimeout(() => {
				setAddClass('add-to-cart-button');
			}, DELAY);
			return () => clearTimeout(timeout);
		}
		setAddClass('add-to-cart-button invisible');
	}, [open]);
	useEffect(() => {
		setAmount(0);
	}, [item]);

	if (!item) {
		return <div className='loading-item'>
			<CircularProgress color='secondary' />
		</div>;
	}
	const getImage = (kind, imgSize = 'Small') => moodImages?.[`${kind}${imgSize}`];
	const images = moodImageNames.filter(base => getImage(base));
	if (openLightBox !== undefined) {
		return <div className='modalBody'>
			<Lightbox
				mainSrc={getImage(images[openLightBox], 'Medium')}
				nextSrc={getImage(images[(openLightBox + 1) % images.length], 'Medium')}
				prevSrc={getImage(images[(openLightBox + images.length - 1) % images.length], 'Medium')}
				onMoveNextRequest={() => setOpenLightBox((openLightBox + 1) % images.length)}
				onMovePrevRequest={() => setOpenLightBox((openLightBox + images.length - 1) % images.length)}
				onCloseRequest={() => setOpenLightBox(undefined)}
			/>
		</div>;
	}
	return <div className='modalBody' key={sku}>
		<div className='modalBody-holder'>
			<motion.div
				className='carouselCard'
				initial={{ x: '-100%' }}
				animate={{ x: 0 }}
				transition={{ ease: 'easeOut', duration: 0.5 }}
			>
				<div className='carouselCardImage-holder' onClick={() => setOpenLightBox(0)} >
					<img className='carouselCardImage' src={imageMedium} key={imageMedium} />
					<div className='carouselCardImageMinis-holder'>
						{
							images.length ? images.map((image, i) => {
								if (i !== 0)return <img key={image} className='carouselCardImageMinis' src={getImage(image)} />;
							}) : <CircularProgress color="secondary" />
						}
					</div>
				</div>
				<div className='carouselCard-holder'>

					<div className='carouselCard-content'>
						<div className='carouselCard-content-head'>
							<div className='carouselCard-content-head-price'>

							</div>
							<div className='carouselCard-content-head-title'>
								<span className='carouselCard-content-title'>{description}</span>
							</div>

						</div>
						<div className='carouselCard-content-body'>
							<span className='carouselCard-content-title'>{productgroup}</span>
						</div>
						<div className='carouselCard-content-body'>
							<span className='carouselCard-content-title'>{sku}</span>
						</div>
						{availability > 0 && <div className='carouselCard-content-body'>
							<span className='carouselCard-content-title'>{t('stock_interval', { postProcess: 'interval', count: availability })}</span>
						</div>}
						<div className='carouselCard-content-body'>
							<span className='carouselCard-content-title'>
								<Currency
									quantity={price}
									currency={currency}
									discount={discount}
								/></span>
						</div>
						<div className='carouselCard-content-foot'>
							<span className='carouselCard-content-title'>{size}</span>
						</div>
						{eta && <div className='carouselCard-content-foot'>
							<span className='carouselCard-content-title'>{t('eta')} {eta.format && eta.format(t('etaFormat')) || eta}</span>
						</div>}
						<div className='carouselCard-content-price'>
							<Currency
								quantity={price}
								currency={currency}
								discount={discount}
							/>
						</div>
						<div className='carouselCard-content-buttons'>
							{availability > 0 ?
								<div className='add-to-cart-section'>
									<div className='add-to-cart-amounts'>
										<motion.button
											className='add-to-cart-min'
											whileHover={{ scale: 1.1 }}
											whileTap={{ scale: 0.9 }}
											onClick={() => setAmount(Math.max(0, amount - item.salesQuantity))}
										>
											<RemoveIcon />
										</motion.button>
										<span className='add-to-cart-amount'>
											{amount}
										</span>
										<motion.button
											className='add-to-cart-plus'
											whileHover={{ scale: 1.1 }}
											whileTap={{ scale: 0.9 }}
											onClick={() => setAmount(Math.min(amount + item.salesQuantity, availability))}
										>
											<AddIcon />
										</motion.button>
									</div>
									<motion.button
										className={addClass}
										whileHover={{ scale: 1.1 }}
										whileTap={{ scale: 0.9 }}
										onClick={() => {
											addCartItem(item, amount);
											setAmount(1);
										}}
									>
										<AddShoppingCartIcon />
									</motion.button>
								</div>
								: <div className='item-not-available'>{t('itemUnavailable')}</div>}
						</div>
					</div>
				</div>
			</motion.div>
		</div>
	</div>;
}
